import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ChevronDown({ iconClass, width, height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 512 512"
      className={iconClass}
      width={width}
      height={height}
    >
      <path fill="currentColor" d="M256 417.9l17-17L465 209l17-17L448 158.1l-17 17-175 175L81 175l-17-17L30.1 192l17 17L239 401l17 17z" />
    </svg>
  );
}
